export default "__VITE_ASSET__BgDjVUv8__"